import React, { PropsWithChildren } from 'react';

import ListFilters from '../Components/ListFilters';
import { IListItem } from '../Utils/IListItem';
import InnerList from './Components/InnerList';
import { IListProps } from '../Utils/IListProps';
import { useSelectedFilter } from '../Hooks/useSelectedFilter.hook';

const List = <T extends IListItem>(props: PropsWithChildren<IListProps<T>>) => {
  const {
    buttonSetClassName,
    buttonSetStyle,
    className,
    context,
    customFilter,
    customSort,
    filters,
    initialFilter,
    itemHeight,
    items,
    listHeight,
    onSelect,
    renderItem,
    sorting,
    staffContext,
    title
  } = props;

  const [selected, setSelected] = useSelectedFilter({ initialFilter });

  return (
    <div className={`list ${className}`}>
      {title && <h3>{title}</h3>}

      <ListFilters
        buttonSetClassName={buttonSetClassName}
        buttonSetStyle={buttonSetStyle}
        filters={filters as any}
        onSelect={onSelect}
        selected={selected}
        setSelected={setSelected}
        staffContext={staffContext}
      />

      <InnerList
        customSort={customSort}
        sorting={sorting}
        itemHeight={itemHeight}
        renderItem={renderItem}
        context={context}
        listHeight={listHeight}
        items={items}
        customFilter={customFilter}
        filters={filters}
        selected={selected}
      />
    </div>
  );
};

export default List;
